'use client';

import { forwardRef } from 'react';

const NavigationTrigger = forwardRef(({ setMobileMenuVisible, mobileMenuVisible }, ref) => {
  return (
    <button
      aria-label='Toggle navigation panel'
      onClick={() => {
        setMobileMenuVisible(x => !x);
      }}
      className='flex h-5 w-5 flex-none items-center justify-center'
      type='button'
      ref={ref}
    >
      {mobileMenuVisible ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          fill='none'
          viewBox='0 0 16 16'
        >
          <path
            stroke='#403732'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M15 15L1 1m14 0L1 15'
          />
          <path
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeOpacity='0.2'
            strokeWidth='1.5'
            d='M15 15L1 1m14 0L1 15'
          />
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='16'
          fill='none'
          viewBox='0 0 20 16'
        >
          <path
            fill='#403732'
            fillRule='evenodd'
            d='M19.915.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
          <path
            fill='#000'
            fillOpacity='0.2'
            fillRule='evenodd'
            d='M19.915.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
          <path
            fill='#403732'
            fillRule='evenodd'
            d='M19.915 7.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
          <path
            fill='#000'
            fillOpacity='0.2'
            fillRule='evenodd'
            d='M19.915 7.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
          <path
            fill='#403732'
            fillRule='evenodd'
            d='M19.915 14.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
          <path
            fill='#000'
            fillOpacity='0.2'
            fillRule='evenodd'
            d='M19.915 14.227H0v1h20v-1h-.085z'
            clipRule='evenodd'
          />
        </svg>
      )}
    </button>
  );
});

export default NavigationTrigger;
